import React, { memo } from 'react'
import { BounceLoader } from 'react-spinners'

type Props = {
    loading: boolean
    children: React.ReactNode
}

const CommonLoadingSpinner: React.FC<Props> = memo((props: Props) => {
    return props.loading ? <div className='loadingContainer'>
        <BounceLoader color="#DE841B" />
    </div>
        : <>
            {props.children}
        </>
})

export default CommonLoadingSpinner